import {assign, concat, flow, get, reduce} from '@logistics-frontend/utils'
import {useMemo} from 'react'

import {Poll, PollUserAnswerChoice, Subpoll} from 'src/api'

import {FormType} from './Form.types'

const getUserChoices: (poll: Poll) => FormType = flow(
  get('subpolls'),
  reduce(
    (acc: PollUserAnswerChoice[], {user_choices}: Subpoll) => (user_choices ? concat(acc, user_choices) : acc),
    [],
  ),
  reduce(
    (choicesAcc: FormType, choice: PollUserAnswerChoice) =>
      assign(choicesAcc, {[choice.question_id]: choice.answers_ids}),
    {},
  ),
)

export const useDefaultValues = (poll: Poll): FormType => {
  const defaultValues = useMemo<FormType>(() => getUserChoices(poll), [poll])

  return defaultValues
}
